const infoMedia = process.env.REACT_APP_INFOMEDIA;

const HeaderMain = {
    "MF": [
        {
            "Heading": "Home",
            "url": "/",
            "class": "fas fa-home"
        },
        {
            "Heading": "About Us",
            "url": "/about-us/overview",
            "class": "fas fa-users"
        },
        {
            "Heading": "Our Funds",
            "url": "/mutual-funds",
            "class": "fas fa-piggy-bank"
        },
        {
            "Heading": "Nav",
            "url": "/nav/latest-nav",
            "class": "fas fa-coins"
        },
        {
            "Heading": "Downloads",
            "url": "/download/forms",
            "class": "fas fa-file-download"
        },
        {
            "Heading": "Tools",
            "url": "/tools/sip-return-calculator",
            "class": "fas fa-calculator"
        },
        {
            "Heading": "NEWS & INSIGHTS",
            "url": "/Media-Room/Press-Release",
            "class": "fas fa-photo-video",
            "dropDown": [
                {
                    "title": "Blog",
                    "url": infoMedia
                },
                {
                    "title": "Press-Release",
                    "url": "/Media-Room/Press-Release"
                },
                {
                    "title": "Interviews",
                    "url": "/Media-Room/Press-Release",
                    "subDropDown": [
                        {
                            "title": "Print",
                            "url": "/Media-Room/Interviews/Print"
                        },
                        {
                            "title": "Online",
                            "url": "/Media-Room/Interviews/Online"
                        },
                        {
                            "title": "Television",
                            "url": "/Media-Room/Interviews/TV"
                        }
                    ]
                },
                {
                    "title": "News",
                    "url": "/Media-Room/Press-Release",
                    "subDropDown": [
                        {
                            "title": "Print",
                            "url": "/Media-Room/News/Print"
                        },
                        {
                            "title": "Online",
                            "url": "/Media-Room/News/Online"
                        },
                        {
                            "title": "Television",
                            "url": "/Media-Room/News/TV"
                        }
                    ]
                }
            ]
        },
        {
            "Heading": "Faq",
            "url": "/faq?key=mutualfund",
            "class": "fas fa-question-circle"
        },
        {
            "Heading": "Contact Us",
            "url": "/contact-us",
            "class": "fas fa-phone-volume"
        }
    ],
    "Index": [
        {
            "Heading": "Home",
            "url": "/index-fund",
            "class": "fas fa-home"
        },
        {
            "Heading": "About Us",
            "url": "/about-us/overview?key=indexfunds",
            "class": "fas fa-users"
        },
        {
            "Heading": "Our Funds",
            "url": "/mutual-funds/?key=indexfunds",
            "class": "fas fa-piggy-bank"
        },
        {
            "Heading": "Nav",
            "url": "/nav/latest-nav?key=indexfunds",
            "class": "fas fa-coins"
        },
        {
            "Heading": "Downloads",
            "url": "/download/index-fund/addendums",
            "class": "fas fa-file-download"
        },
        {
            "Heading": "Tools",
            "url": "/tools/sip-return-calculator?key=indexfunds",
            "class": "fas fa-calculator"
        },
        {
            "Heading": "NEWS & INSIGHTS",
            "url": "/Media-Room/Press-Release?key=indexfunds",
            "class": "fas fa-photo-video",
            "dropDown": [
                {
                    "title": "Blog",
                    "url": infoMedia
                },
                {
                    "title": "Press-Release",
                    "url": "/Media-Room/Press-Release"
                },
                {
                    "title": "Interviews",
                    "url": "/Media-Room/Press-Release",
                    "subDropDown": [
                        {
                            "title": "Print",
                            "url": "/Media-Room/Interviews/Print"
                        },
                        {
                            "title": "Online",
                            "url": "/Media-Room/Interviews/Online"
                        },
                        {
                            "title": "Television",
                            "url": "/Media-Room/Interviews/TV"
                        }
                    ]
                },
                {
                    "title": "News",
                    "url": "/Media-Room/Press-Release",
                    "subDropDown": [
                        {
                            "title": "Print",
                            "url": "/Media-Room/News/Print"
                        },
                        {
                            "title": "Online",
                            "url": "/Media-Room/News/Online"
                        },
                        {
                            "title": "Television",
                            "url": "/Media-Room/News/TV"
                        }
                    ]
                }
            ]
        },
        {
            "Heading": "Faq",
            "url": "/faq?key=indexfunds",
            "class": "fas fa-question-circle"
        },
        {
            "Heading": "Contact Us",
            "url": "/contact-us?key=indexfunds",
            "class": "fas fa-phone-volume"
        }
    ],
    "ETF": [
        {
            "Heading": "Home",
            "url": "/etf",
            "class": "fas fa-home"
        },
        {
            "Heading": "Nav",
            "url": "/nav/etf/latest-nav",
            "class": "fas fa-coins"
        },
        {
            "Heading": "Downloads",
            "url": "/download/etf/addendums",
            "class": "fas fa-file-download"
        },
        {
            "Heading": "Tools",
            "url": "/tools/sip-return-calculator",
            "class": "fas fa-calculator"
        },
        {
            "Heading": "NEWS & INSIGHTS",
            "url": "/Media-Room/Press-Release",
            "class": "fas fa-photo-video",
            "dropDown": [
                {
                    "title": "Blog",
                    "url": infoMedia
                },
                {
                    "title": "Press-Release",
                    "url": "/Media-Room/Press-Release"
                },
                {
                    "title": "Interviews",
                    "url": "/Media-Room/Press-Release",
                    "subDropDown": [
                        {
                            "title": "Print",
                            "url": "/Media-Room/Interviews/Print"
                        },
                        {
                            "title": "Online",
                            "url": "/Media-Room/Interviews/Online"
                        },
                        {
                            "title": "Television",
                            "url": "/Media-Room/Interviews/TV"
                        }
                    ]
                },
                {
                    "title": "News",
                    "url": "/Media-Room/Press-Release",
                    "subDropDown": [
                        {
                            "title": "Print",
                            "url": "/Media-Room/News/Print"
                        },
                        {
                            "title": "Online",
                            "url": "/Media-Room/News/Online"
                        },
                        {
                            "title": "Television",
                            "url": "/Media-Room/News/TV"
                        }
                    ]
                }
            ]
        },
        {
            "Heading": "Faq",
            "url": "/faq?key=etf",
            "class": "fas fa-question-circle"
        },
        {
            "Heading": "Contact Us ",
            "url": "/contact-us?key=etf",
            "class": "fas fa-phone-volume"
        }
    ],
    "AIF": [
        {
            "Heading": "Home",
            "url": "/aif",
            "class": "fas fa-home"
        },
        {
            "Heading": "Downloads",
            "url": "/downloadAIF/Forms",
            "class": "fas fa-file-download"
        },
        {
            "Heading": "",
            "url": "",
            "class": ""
        },
        {
            "Heading": "",
            "url": "",
            "class": ""
        }
    ],
    "international": [
        {
            "Heading": "Home",
            "url": "/InternationalBusiness",
            "class": "fas fa-home"
        },
        {
            "Heading": "Downloads",
            "url": "/downloadIB/document-disclosure",
            "class": "fas fa-file-download"
        },
        {
            "Heading": "NEWS & INSIGHTS",
            "url": "/Media-Room/Press-Release",
            "class": "fas fa-photo-video",
            "dropDown": [
                {
                    "title": "Blog",
                    "url": infoMedia
                },
                {
                    "title": "Press-Release",
                    "url": "/Media-Room/Press-Release"
                },
                {
                    "title": "Interviews",
                    "url": "/Media-Room/Press-Release",
                    "subDropDown": [
                        {
                            "title": "Print",
                            "url": "/Media-Room/Interviews/Print"
                        },
                        {
                            "title": "Online",
                            "url": "/Media-Room/Interviews/Online"
                        },
                        {
                            "title": "Television",
                            "url": "/Media-Room/Interviews/TV"
                        }
                    ]
                },
                {
                    "title": "News",
                    "url": "/Media-Room/Press-Release",
                    "subDropDown": [
                        {
                            "title": "Print",
                            "url": "/Media-Room/News/Print"
                        },
                        {
                            "title": "Online",
                            "url": "/Media-Room/News/Online"
                        },
                        {
                            "title": "Television",
                            "url": "/Media-Room/News/TV"
                        }
                    ]
                }
            ]
        },
        {
            "Heading": "",
            "url": "",
            "class": ""
        },
        {
            "Heading": "",
            "url": "",
            "class": ""
        }
    ]
}
export default HeaderMain